<script lang="ts" setup>
import { formatUnits } from 'viem';

import { useMetaframe } from '@/composables/useMetaframe.client';
import { useBreakpoint, useEventModalsStore, useProviderConfig, useUserStore } from '#imports';
import type { ErrorBalance } from '~/service/utils/eventEmitter';

const { onEvents, offEvents, setIsMobile } = useMetaframe();

const { isMobile } = useBreakpoint();

const handleEvents = (event: Event) => {
    console.log(`Событие ${event.type} обработано`, event);
};

const { isDesktop } = useDevice();

const events = [
    '@metaframe-partner-events:app-loaded',
    '@metaframe-partner-events:login-successful',
    '@metaframe-partner-events:logout-successful'
] as const satisfies MetaframeEventName[];

const { eventEmitter } = useEVMCore();
const { user, network } = storeToRefs(useUserStore());
const modalEventsStore = useEventModalsStore();
const {
    map: { chainMap },
    utils: { isEvmErc1155 }
} = useProviderConfig()(['map', 'utils']);

const parseSafeBigInt = (value: string) => {
    try {
        return BigInt(value);
    }
    catch {
        return 0n;
    }
};

const formatTokenAmount = (weiAmount: string, decimals: number) => {
    return formatUnits(parseSafeBigInt(weiAmount), decimals);
};

onMounted(() => {
    onEvents(events, handleEvents);
    setIsMobile(isMobile.value);

    eventEmitter.on('balance', {
        key: 'app',
        onSuccess: () => {
            console.log('balance onSuccess');
        },
        onError: (error) => {
            const err = error as Error;
            const data = JSON.parse(err.message) as ErrorBalance;

            if (network.value && user.value) {
                modalEventsStore.add(
                    {
                        type: 'topup',
                        images: [],
                        status: '',
                        imageState: 'error',
                        heading: 'Top up your account',
                        content: [
                            {
                                'Your balance:': `${formatTokenAmount(data.myBalance, chainMap[network.value].nativeCurrency.decimals)} ${data.currency}`
                            },
                            {
                                'You need:': `${formatTokenAmount(data.needSum, chainMap[network.value].nativeCurrency.decimals)} ${data.currency} + gas fees`
                            },
                            {
                                label: `Your wallet:`,
                                wallet: user.value,
                                isInput: true
                            }
                        ],
                        button: {
                            callback: () => modalEventsStore.removeByType('topup'),
                            title: 'Continue'
                        }
                    }
                );
            }
        },
        onLoad: (loading) => {
            console.log(loading, 'balance isLoading');
        }
    });
});

onBeforeUnmount(() => {
    offEvents(events, handleEvents);
    eventEmitter.off('balance', 'app');
});

// TODO для перезагрузки после коннекта с метамаском
if (import.meta.client && !isDesktop) {
    document.addEventListener('visibilitychange', () => {
        if (!document.hidden) {
            const connecting = localStorage.getItem('connecting');
            if (connecting === 'true') {
                localStorage.removeItem('connecting');
                location.reload();
            }
        }
    });
}

</script>
<template>
  <Alerts />
  <NuxtLoadingIndicator color="#7353fe" />
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
  <ClientOnly>
    <template #fallback></template>
    <Teleport to="body">
      <ModalSwitchNetwork />
    </Teleport>
  </ClientOnly>
</template>
